import { render, staticRenderFns } from "./vRecipePrintout.vue?vue&type=template&id=5606b1da&scoped=true"
import script from "./vRecipePrintout.vue?vue&type=script&setup=true&lang=ts"
export * from "./vRecipePrintout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vRecipePrintout.vue?vue&type=style&index=0&id=5606b1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606b1da",
  null
  
)

export default component.exports